"use client";

import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Heritage() {
  const {
    ref: imageRef,
    isVisible: imageVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: contentRef,
    isVisible: contentVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const paragraphs = ["Bedrock Safety Engineering operates on the principle that fire protection is a rigorous engineering discipline, not a compliance checkbox. Our methodology integrates advanced risk modeling with deep industrial expertise, ensuring that every facility we assess meets the highest standards of structural and operational resilience.", "We provide insurance underwriters and industrial operators with the clarity required to manage complex hazards. By combining forensic analysis with predictive modeling, we deliver actionable insights that protect assets, minimize downtime, and secure the continuity of critical operations in aerospace, pharmaceutical, and manufacturing sectors."];
  return <section data-section-id="15915" id="our-technical-heritage" className="bg-background text-foreground py-24 md:py-32">
      <div className="mx-auto max-w-[72rem] px-6 md:px-12 lg:px-20">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          {}
          <div ref={imageRef} className="lg:col-span-5 transition-all duration-[600ms] ease-out" style={{
          opacity: imageVisible ? 1 : 0,
          transform: imageVisible ? "translateY(0)" : "translateY(16px)",
          transitionTimingFunction: "cubic-bezier(0.22, 1, 0.36, 1)"
        }}>
            <div className="relative overflow-hidden border border-border aspect-[3/2] lg:aspect-[4/5]">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1705042/img/industrial_engineering_site_assessment.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1705042/img/industrial_engineering_site_assessment.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1705042/img/industrial_engineering_site_assessment.png-wvc-sizes" alt="Engineer conducting a technical site assessment at a large-scale industrial facility" loading="lazy" decoding="async" className="h-full w-full object-cover transition-transform duration-[1400ms] ease-out" style={{
              transform: imageVisible ? "scale(1.03)" : "scale(1)"
            }} />
              <div aria-hidden="true" className="pointer-events-none absolute inset-0" style={{
              boxShadow: "inset 0 0 80px hsl(240 100% 25% / 0.08)"
            }} />
            </div>
          </div>

          {}
          <div ref={contentRef} className="lg:col-span-7 lg:pl-4">
            {}
            <div className="transition-all duration-[600ms]" style={{
            opacity: contentVisible ? 1 : 0,
            transform: contentVisible ? "translateY(0)" : "translateY(16px)",
            transitionTimingFunction: "cubic-bezier(0.22, 1, 0.36, 1)",
            transitionDelay: "0ms"
          }}>
              <span className="text-xs font-bold uppercase tracking-[0.15em] text-primary">
                Our Technical Heritage
              </span>
            </div>

            {}
            <h2 className="font-serif font-semibold text-foreground mt-4 transition-all duration-[600ms]" style={{
            fontSize: "clamp(2rem, 3.6vw, 3.25rem)",
            letterSpacing: "-0.01em",
            lineHeight: 1.2,
            opacity: contentVisible ? 1 : 0,
            transform: contentVisible ? "translateY(0)" : "translateY(16px)",
            transitionTimingFunction: "cubic-bezier(0.22, 1, 0.36, 1)",
            transitionDelay: "80ms"
          }}>
              Safety is <em className="italic text-primary font-normal">not</em> an afterthought.
            </h2>

            {}
            <div className="mt-6 h-px w-16 bg-border transition-all duration-[600ms]" style={{
            opacity: contentVisible ? 1 : 0,
            transitionDelay: "160ms"
          }} />

            {}
            <div className="mt-8 space-y-6">
              {paragraphs.map((paragraph, i) => <p data-index={i} key={i} className="font-default font-normal text-foreground transition-all duration-[600ms]" style={{
              fontSize: "clamp(1.125rem, 1.2vw, 1.25rem)",
              lineHeight: 1.6,
              opacity: contentVisible ? 1 : 0,
              transform: contentVisible ? "translateY(0)" : "translateY(16px)",
              transitionTimingFunction: "cubic-bezier(0.22, 1, 0.36, 1)",
              transitionDelay: `${240 + i * 80}ms`
            }}>
                  {paragraph}
                </p>)}
            </div>

            {}
            <div className="mt-10 transition-all duration-[600ms]" style={{
            opacity: contentVisible ? 1 : 0,
            transform: contentVisible ? "translateY(0)" : "translateY(16px)",
            transitionTimingFunction: "cubic-bezier(0.22, 1, 0.36, 1)",
            transitionDelay: "480ms"
          }}>
              <Link to="#" className="group inline-flex items-center gap-2 text-foreground font-medium text-sm border-b border-primary pb-1 transition-all duration-150 hover:border-b-2">
                <span>Explore our services</span>
                <ArrowRight className="h-4 w-4 text-primary transition-transform duration-200 group-hover:translate-x-1" />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>;
}